import * as React from "react";

const SvgDotUnselected = (props) => (
  <svg
    width={35}
    height={34}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#dot-unselected_svg__a)">
      <circle cx={17.4} cy={17} r={7} fill="#DDD" />
      <circle cx={17.4} cy={17} r={6.5} stroke="#fff" />
    </g>
    <defs>
      <filter
        id="dot-unselected_svg__a"
        x={0.4}
        y={0}
        width={34}
        height={34}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1913_17248"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1913_17248"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default SvgDotUnselected;
